import { useCallback } from 'react'

import { usePrivacyPreferences } from '@contexts/PrivacyPreferencesContext'
import {
  trackReleaseCampaignCtaClick,
  trackReleaseCampaignView
} from '@services/releaseCampaignAnalytics'

export function useReleaseCampaignAnalytics(campaign) {
  const { categories, globalPrivacyControl } = usePrivacyPreferences()
  const analyticsAllowed =
    categories.analytics === true && !globalPrivacyControl

  const trackView = useCallback(
    placement => {
      trackReleaseCampaignView({
        analyticsAllowed,
        campaign,
        placement
      })
    },
    [analyticsAllowed, campaign]
  )

  const trackCtaClick = useCallback(
    (placement, destination) => {
      trackReleaseCampaignCtaClick({
        analyticsAllowed,
        campaign,
        destination,
        placement
      })
    },
    [analyticsAllowed, campaign]
  )

  return { trackCtaClick, trackView }
}
